import classnames from 'classnames';
import React from 'react';
import { FormCheck } from 'react-bootstrap';
import { UseFormRegisterReturn } from 'react-hook-form';
import FormLabel from '../FormLabel/FormLabel';
import styles from './checkbox.module.scss';

interface CheckbocHookFormProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string | null;
  register: UseFormRegisterReturn;
  text?: string;
}

interface BasicCheckbox extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: never;
  error?: never;
  register?: never;
}

type OwnProps = CheckbocHookFormProps | BasicCheckbox;

const Checkbox = (props: OwnProps) => {
  if (props.register) {
    const { label, error, register, text, ...inputProps } = props;

    return (
      <div className={classnames(props.className)}>
        {label ? (
          <FormLabel
            label={label || ''}
            required={props.required}
            error={error}
          />
        ) : null}
        <FormCheck
          {...register}
          {...inputProps}
          custom
          id={register.name}
          aria-label={register.name}
          type="checkbox"
          label={text}
          className={styles.checkboxHookForm}
        />
      </div>
    );
  }
  return (
    <label className={styles.checkboxContainer}>
      <input type="checkbox" {...props} role="checkbox" />
      <span className={styles.checkmark}></span>
    </label>
  );
};

export default Checkbox;
